import ApiService from './ApiService';

export default class ContactService {
  static sendContactMessage(data) {
    return ApiService.post('/contact', data);
  }

  static sendContactPersonCharge(email) {
    return ApiService.post('/contact/person-charge', email);
  }

  static sendContactRequestTrialDemo(data) {
    return ApiService.post('/contact/request-trial-demo', data);
  }

  static sendContactRequestFapiao(data) {
    return ApiService.post('/contact/request-fapiao', data);
  }

  static sendContactSalesTeam(data) {
    return ApiService.post('/contact/contact-sales', data);
  }
}
